import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable, take } from 'rxjs';

import * as fromStore from 'src/app/_store/_reducers';

@Injectable({
  providedIn: 'root',
})
export class NotSalesOpsGuard {
  constructor(private store: Store<fromStore.State>) {}
  canActivate(): Observable<boolean> {
    return this.store
      .select((state) => state.user.isSalesOps)
      .pipe(take(1))
      .pipe(
        map((isSalesOps) => {
          return !isSalesOps;
        })
      );
  }
}
